import { useEffect, useState } from "react";
import { useFormContext } from 'react-hook-form-mui';
import { ColorPicker, useColor } from "react-color-palette";
import { Box, IconButton } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

const ColorInputElement = ({ name }) => {

    const { getValues, setValue } = useFormContext();

    const [color, setColor] = useColor("red");

    const [openCustomColor, setOpenCustomColor] = useState(false)
    const [currentColor, setCurrentColor] = useState('')

    useEffect(() => {
        if (color){
            // setValue(name, color.hex);
        }
    }, [color]);

    
    const colorsList = [
        {
            color: '#FFE700'
        }, 
        {
            color: '#74EE15'
        }, 
        {
            color: '#1F51FF'
        }, 
        {
            color: '#FF1493'
        },
        {
            color: '#4DEEEA'
        }
    ]

    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '10px',
                flexWrap: 'wrap'
            }}>
                {!openCustomColor ? colorsList.map((c, index) => {
                    return (
                        <Box component="button" type="button" key={index} onClick={() => {
                            setCurrentColor(c.color)
                            setValue(name, c.color)
                        }} sx={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: c.color,
                            border: currentColor == c.color || getValues(name) == c.color ? '2px solid #fff' : 'none',
                            cursor: 'pointer',
                        }}></Box>
                    )
                }) : null}
                <IconButton size="large" onClick={() => setOpenCustomColor(!openCustomColor)}>
                    {openCustomColor ? (
                        <CloseIcon />
                    ) : (
                        <AddCircleOutlineIcon />
                    )}
                </IconButton>
            </Box>
            {openCustomColor ? (
                <ColorPicker hideInput={["rgb", "hsv"]} color={color} onChange={(c) => {setColor(c); setValue(name, c.hex);}} />
            ) : null}
        </>
    )

};

export default ColorInputElement;